import { render, staticRenderFns } from "./DeviceData.vue?vue&type=template&id=b8d31b02&scoped=true&"
import script from "./DeviceData.vue?vue&type=script&lang=ts&"
export * from "./DeviceData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d31b02",
  null
  
)

export default component.exports